<template>
  <div class="dados-local">
    <Card title="Dados do Local">
      <lista-component :headers="headers" :items="analise" />
    </Card>
  </div>
</template>
<script>
import ListaComponent from "@/components/Lista/ListaComponent";
import Card from "@/components/Cards/Card";

export default {
  name: "DadosLocal",
  components: { Card, ListaComponent },
  props: {
    analise: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        { text: "Descrição", value: "local_cometido" },
        { text: "Cidade", value: "municipio_cometido" },
        { text: "UF", value: "uf_cometido" },
      ],
    };
  },
};
</script>
